import { useUpdateUserSettings } from 'features/user';
import { useCallback } from 'react';
import { ID } from 'shared/types/id';

export const useReorderSmartLists = () => {
  const updateSettings = useUpdateUserSettings();

  return useCallback(
    (ids: ID[]) =>
      updateSettings({
        smartListSorting: ids,
      }),
    [updateSettings],
  );
};
